<template>
    <div class="hamburger-component"
         :class="{'active' : mobileMenu}"
         id="hamburger_component"
         @click="toggleMenu()">
        <div class="hamburger-bar hamburger-bar--1"></div>
        <div class="hamburger-bar hamburger-bar--2"></div>
        <div class="hamburger-bar hamburger-bar--3"></div>
    </div>
</template>

<script>
    export default {
        computed: {
            mobileMenu () {
                return this.$store.getters.mobileMenu
            }
        },
        methods: {
            toggleMenu () {
                this.$store.commit('toggleMobileMenu')
            }
        }
    }
</script>

<style lang="scss">
    @import "../../../../../assets/scss/_colors.scss";

    .hamburger-component{
        display: none;
    }

    @media(max-width: 991px){
        .hamburger-component{
            display: block;
            position: absolute;
            top: 8px;
            bottom: 0;
            right: 0;
            width: 36px;
            height: 36px;
            cursor: pointer;
        }

        .hamburger-bar{
            position: absolute;
            left: 6px;
            width: 30px;
            height: 4px;
            background: $d-gray;
            transition: 200ms all linear;
        }

        .hamburger-bar--1{
            top: 5px;
        }

        .hamburger-bar--2{
            top: 14px;
        }

        .hamburger-bar--3{
            top: 23px;
        }

        .hamburger-component{
            &.active{
                .hamburger-bar--1{
                    top: 14px;
                    transform: rotate(45deg);
                }

                .hamburger-bar--2{
                    opacity: 0;
                }

                .hamburger-bar--3{
                    top: 15px;
                    transform: rotate(-45deg);
                }
             }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/menu/MainMenuHamburger.vue